import endpoint from "../../config/endpoints";

export const SalesTeamJson = {
  showSaveNextBtn: true,
  formPath: "/sales-team-claim-Form",
  apiBaseURL: endpoint.claimApplyHeader,
  changeExcel: endpoint.exportData,
  screenTitle: "Sales Team Claim",
  showAddButton: true,
  showPdfDownload: false,
  pdfFileName: "MyClaim",
  showExcelDownload: true,
  excelFileName: "MyClaim",
  tableColumnsToFilter: [
    {
      columnDisplayName: "Employee Code",
      columnKeyName: "employeeCode",
      isChecked: true,
    },
    {
      columnDisplayName: "Sales Team Name",
      columnKeyName: "salesTeam",
      isChecked: true,
    },
    {
      columnDisplayName: "Reporting To",
      columnKeyName: "authoritySalesPersonName",
      isChecked: true,
    },
    {
      columnDisplayName: "Date",
      columnKeyName: "date",
      isChecked: true,
    },
    {
      columnDisplayName: "Claim Title",
      columnKeyName: "name",
      isChecked: true,
    },
    {
      columnDisplayName: "Amount",
      columnKeyName: "claimAmt",
      isChecked: true,
    },
    {
      columnDisplayName: "Type",
      columnKeyName: "claimType",
      isChecked: true,
    },
    {
      columnDisplayName: "No.Of Days",
      columnKeyName: "noOfDays",
      isChecked: true,
    },
    {
      columnDisplayName: "Status",
      columnKeyName: "status",
      isChecked: true,
    },
  ],
  fieldMeta: [
    {
      label: "Name",
      controlType: "textfield",
      placeHolder: "Name",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      autoFocus: true,
      dataKey: "name",
      isMandatory: true,
      uniqueValidation: true,
    },
  ],
  searchList: [
    {
      label: "Month",
      controlType: "monthpicker",
      placeHolder: "",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      dataKey: "month",
      isMandatory: true,
    },
  ],
};
